import * as Yup from 'yup';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
// form
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import moment from 'moment';
// @mui
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { Stack, IconButton, InputAdornment, TextField } from '@mui/material';
import { DesktopDatePicker, LoadingButton, LocalizationProvider } from '@mui/lab';
import 'react-dropzone-uploader/dist/styles.css';
// components
import Iconify from '../../../components/Iconify';
import { FormProvider, RHFCheckbox, RHFTextField } from '../../../components/hook-form';
import RHFSelect from '../../../components/hook-form/RHFSelect';
import tracker from '../../../api/tracker';
import RHFFileInput from '../../../components/hook-form/RHFFileInput';
import Label from '../../../components/Label';
// utils
import { compressImage } from '../../../utils/imageCompression';

// ----------------------------------------------------------------------

export default function AnnouncementForm({ announcement }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    if (announcement) {
      const fields = ['body', 'title', 'url', 'active'];
      fields.forEach((field) => setValue(field, announcement[field]));
    }
  }, [announcement]);

  const AnnouncementSchema = Yup.object().shape({
    // title: Yup.string().required(t('Required')),
    // body: Yup.string().required('Required'),
  });

  const defaultValues = {
    active: 1,
    body: '',
    title: '',
    url: '',
    image: null,
    mobile_image: null,
  };

  const methods = useForm({
    resolver: yupResolver(AnnouncementSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    setValue,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = async (data) => {
    if (data.image && data.image[0]) {
      try {
        const compressedImage = await compressImage(data.image[0], {
          maxSizeMB: 5,
          maxWidthOrHeight: 1920,
        });
        data.image = compressedImage;
      } catch (error) {
        console.error('Error compressing image:', error);
        return;
      }
    }

    // Comprimir la imagen móvil si existe
    if (data.mobile_image && data.mobile_image[0]) {
      try {
        const compressedMobileImage = await compressImage(data.mobile_image[0], {
          maxSizeMB: 5,
          maxWidthOrHeight: 1080,
        });
        data.mobile_image = compressedMobileImage;
      } catch (error) {
        console.error('Error compressing mobile image:', error);
        return;
      }
    }

    console.log(data);
    try {
      if (!announcement) {
        await tracker.post('announcements', data, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
      } else {
        await tracker.post(`announcements/update/${announcement.hashid}`, data, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
      }
      navigate('/dashboard/announcements', { replace: true });
    } catch (error) {
      console.error('Error submitting announcement:', error, error.response?.data || error.message);
    }
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={3}>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
          <RHFTextField name="title" label={t('Title')} />
        </Stack>
        <RHFTextField name="body" label={t('Body')} />

        <div style={{ marginTop: '80px' }}>
          <Label>{t('Imagen')}</Label>
          <Label >2.76 (Ejemplo: 1104×400, 1380×500, 1656×600, 1932×700, 2208×800)</Label>
          <RHFFileInput fileUrl={announcement ? announcement.image : null} name="image" />
        </div>
        <div style={{ marginTop: '80px' }}>
          <Label>{t('Imagen MOVIL')}</Label>
          <Label>1:1 (Ejemplo: 1000x1000, 500x500, 1080x1080)</Label>
          <RHFFileInput
            name="mobile_image"
            fileUrl={announcement && announcement.mobile_image ? announcement.mobile_image : null}
          />
        </div>
        <RHFTextField name="url" label={t('link')} />
        <RHFCheckbox name="active" label="Activo" checked={announcement ? announcement.active : false} />
        <LoadingButton fullWidth size="large" type="submit" variant="contained" loading={isSubmitting}>
          {t('Save')}
        </LoadingButton>
      </Stack>
    </FormProvider>
  );
}
